import { Typography } from "@mui/material"
import { normaliseText } from "./pdf-formatters"

export function PdfTaskOrderChangesRow({ item }) {
    const normalisedPdfTitle = normaliseText(item.title)
    return (
        <>
            <Typography sx={{ fontSize: "10px", color: "#1f2937", py: "8px", borderBottom: "1px solid #edf0f3" }}>
                {normalisedPdfTitle}
            </Typography>
            <Typography
                sx={{
                    fontSize: "10px",
                    color: "#1f2937",
                    py: "8px",
                    borderBottom: "1px solid #edf0f3",
                    textAlign: "right",
                }}
            >
                {item.previousOrder}
            </Typography>
        </>
    )
}
